module.exports = __webpack_public_path__ + "f37b7eea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/steps_video@2x.png
// module id = 1211
// module chunks = 0